<template>
    <input class="text-field default-element-size" :type="type" :placeholder="placeholder" v-model="data">
</template>

<script>
    export default {
        name: "text_field",
        model: {
            prop: 'value',
            event: 'change'
        },
        props:{
            value:{
                required: true
            },
            type: {
                type: String,
                default: "text",
                required: false,
            },
            placeholder:{
                type: String,
                required: false,
            }
        },
        computed: {
            data: {
                get(){
                    return this.value;
                },
                set(v){
                    this.$emit('change', v);
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    input.text-field{
        margin-bottom: 15px;
        padding: 0 16px;
        background-color: $bg_light_plus;
        border: 1px solid rgba(#1D2229, 0);
        color: white;

        font-weight: 500;
        font-size: 16px;
        line-height: 19px;

        @include mobile{
            margin-bottom: 12px;
        }
        &:last-of-type:not(:first-of-type){
            margin-bottom: 24px;

            @include mobile{
                margin-bottom: 20px;
            }
        }

        &::placeholder{
            color: $text_gray;
        }
        &:focus{
            border-color: #1D2229;
        }
        &:disabled{
            background-color: rgba($bg_light_plus, 0);
            color: $bg_line;
            border-color: $bg_light_plus;
        }
    }
</style>